export enum AgreementStatus {
  'aktywna',
  'zablokowana',
  'zamknięta',
  'nieaktywne',
  '-- brak --',
  'nieaktywna',
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/dictonaries/agreement-status.enum.ts